import { Controller } from '@hotwired/stimulus';

import Autocomplete from '@/modules/autocomplete';
import Templates from '@/pages/site/templates';

export default class extends Controller {
  static targets = ['unitResult'];

  connect() {
    new Autocomplete({
      field: $('#complety__unit'),
      keys: ['full_name'],
      result: this.unitResultTarget,
      templates: {
        none: Templates.units.complety.search.none,
        result: Templates.units.complety.show,
        search: Templates.units.complety.search,
      },
    }).create();
  }
}
